import { THEMES } from 'src/constants';
import { softShadows } from '../shadows';

export default {
  name: THEMES.LIME,
  light: {
    palette: {
      type: 'light',
      background: {
        default: '#FAFAFA',
        paper: '#FFFFFF',
        navbar: '#80C43C',
        dark: '#f4f6f8'
      },
      primary: {
        main: '#80C43C',
        contrastText: 'rgba(255,255,255,0.87)'
      },
      secondary: {
        main: '#80C43C',
        contrastText: 'rgba(255,255,255,0.87)'
      },
      text: {
        primary: 'rgba(0, 0, 0, 0.87)',
        secondary: 'rgba(0, 0, 0, 0.6)',
        disabled: 'rgba(0, 0, 0, 0.38)'
      }
    },
    overrides: {
      MuiAppBar: {},
      MuiButton: {},
      MuiListItem: {},
      MuiLinearProgress: {}
    },
    shadows: softShadows
  },
  dark: {
    palette: {
      type: 'dark',
      background: {
        default: '#303030',
        navbar: '#80C43C',
        paper: '#424242',
        dark: '#303030'
      },
      primary: {
        main: '#80C43C',
        contrastText: 'rgba(255,255,255,0.87)'
      },
      secondary: {
        main: '#80C43C',
        contrastText: 'rgba(255,255,255,0.87)'
      },
      text: {
        primary: '#FFFFFF',
        secondary: 'rgba(255, 255, 255, 0.7)',
        disabled: 'rgba(255, 255, 255, 0.5)'
      }
    },
    overrides: {
      MuiAppBar: {},
      MuiButton: {},
      MuiListItem: {},
      MuiLinearProgress: {}
    },
    shadows: softShadows
  }
};
